import { IsoMonth, syntaxFNMA } from '@aloft/toolkit-shared';

import { extractAdjustmentDescription } from './extractAdjustmentDescription.ts';

export const extractDateOfSale = (
  sale: Element,
): {
  status?: syntaxFNMA.UadListingStatus;
  saleDate?: IsoMonth;
  contractDate?: IsoMonth;
} => {
  try {
    const { listingStatus, closeMonth, contractMonth } = syntaxFNMA.dateOfSaleSyntax.decode(
      extractAdjustmentDescription(sale, 'DateOfSale') ?? '',
    );
    return {
      status: listingStatus,
      saleDate: closeMonth,
      contractDate: contractMonth,
    };
  } catch (e: unknown) {
    console.warn('Failed to parse date of sale', e);
    return {};
  }
};
